module.exports = __webpack_public_path__ + "static/media/sad.47330811.jpg";